import { useState } from 'react'

export default function OrganizationForm({ organization, onSubmit, onCancel, loading }) {
  const [formData, setFormData] = useState({
    Name: organization?.Name || '',
    InternalIdentifier: organization?.InternalIdentifier || '',
    Description: organization?.Description || '',
    IsDeleted: false
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit({
      ...formData,
      Description: formData.Description || null,
    })
  }

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Organization Name <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          name="Name"
          value={formData.Name}
          onChange={handleChange}
          required
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., Acme Corp"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Internal Identifier
        </label>
        <input
          type="text"
          name="InternalIdentifier"
          value={formData.InternalIdentifier}
          onChange={handleChange}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="e.g., acme-corp"
        />
        <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">Optional unique identifier for API lookups</p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Description</label>
        <textarea
          name="Description"
          value={formData.Description}
          onChange={handleChange}
          rows={3}
          className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          placeholder="Optional description of this organization"
        />
      </div>

      <div className="flex justify-end space-x-3 pt-4">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600"
        >
          Cancel
        </button>
        <button
          type="submit"
          disabled={loading}
          className="px-4 py-2 text-white bg-primary-500 rounded-lg hover:bg-primary-600 disabled:opacity-50"
        >
          {loading ? 'Saving...' : organization ? 'Update' : 'Create'}
        </button>
      </div>
    </form>
  )
}
